var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJudicialLands({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 90,
    viewBox: "0 0 101 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10675",
    "data-name": "Group 10675",
    transform: "translate(-199.419 -662.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10235",
    "data-name": "Path 10235",
    d: "M-7590.194-21786.561h12.025a.766.766,0,0,1,.582.268l12.979,15.135a.766.766,0,0,1-.081,1.078l-15.594,13.5a.763.763,0,0,1-1.012-.01l-21.816-19.467a.77.77,0,0,1-.255-.607.77.77,0,0,1,.31-.582l12.407-9.16A.766.766,0,0,1-7590.194-21786.561Zm11.673,1.533h-11.42l-11.445,8.451,20.611,18.393,14.508-12.557Z",
    transform: "translate(7833.167 22508.48)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10236",
    "data-name": "Path 10236",
    d: "M-7597.668-21816.336a.767.767,0,0,1,.53.211l15.061,14.393a.768.768,0,0,1,.237.555v8.611a.764.764,0,0,1-.767.764h-11.818l-11.541,9.09a.764.764,0,0,1-.971-.016l-14.057-11.982a.779.779,0,0,1-.269-.58.766.766,0,0,1,.257-.578l22.828-20.275A.773.773,0,0,1-7597.668-21816.336Zm14.295,15.488-14.314-13.68-21.642,19.221,12.908,11,11.256-8.865a.76.76,0,0,1,.474-.164h11.317Z",
    transform: "translate(7820.682 22512.457)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_60",
    "data-name": "Subtraction 60",
    d: "M15.991,23.719a.757.757,0,0,1-.519-.2L.247,9.547A.768.768,0,0,1,0,8.972.777.777,0,0,1,.263,8.4L9.971,0a6.1,6.1,0,0,0,.346,1.729L1.916,9,16.087,22,30.24,13.643,18.217,2.9a5.689,5.689,0,0,0,.675-1.452L32.045,13.2a.771.771,0,0,1-.119,1.235L16.378,23.611A.757.757,0,0,1,15.991,23.719Z",
    transform: "translate(235.902 668.111)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10238",
    "data-name": "Path 10238",
    d: "M-7555.586-21810.07a.763.763,0,0,1,.5.188l16.959,14.8a.762.762,0,0,1,.263.564.772.772,0,0,1-.245.574l-19.688,18.287a.763.763,0,0,1-.521.205.3.3,0,0,1-.042,0,.765.765,0,0,1-.538-.262l-13.076-15.137a.773.773,0,0,1-.187-.5v-8.77a.769.769,0,0,1,.381-.664l15.807-9.182A.774.774,0,0,1-7555.586-21810.07Zm15.814,15.586-15.9-13.881-14.95,8.684v8.045l12.371,14.32Z",
    transform: "translate(7838.279 22505.426)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10648",
    "data-name": "Group 10648",
    transform: "translate(232.36 683.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.721,
    cy: 20.721,
    rx: 20.721,
    ry: 20.721,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.721,
    cy: 20.721,
    rx: 20.221,
    ry: 20.221,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10676",
    "data-name": "Group 10676",
    transform: "translate(8.069 24.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10541",
    "data-name": "Group 10541",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M13.295,394.913a1.838,1.838,0,0,0-1.481-2.926H2.888a1.836,1.836,0,0,0-1.48,2.926A2.627,2.627,0,0,0,0,397.237v.525a.525.525,0,0,0,.525.525H14.176a.525.525,0,0,0,.525-.525v-.525A2.627,2.627,0,0,0,13.295,394.913ZM2.331,393.268a.782.782,0,0,1,.557-.231h8.926a.788.788,0,1,1,0,1.575H2.888a.788.788,0,0,1-.557-1.345Zm-1.281,3.97a1.577,1.577,0,0,1,1.575-1.575h9.451a1.577,1.577,0,0,1,1.575,1.575Z",
    transform: "translate(0.196 -391.791)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108_-_Outline",
    "data-name": "Path 10108 - Outline",
    d: "M2.833,391.737h8.926a2.035,2.035,0,0,1,1.758,3.056,2.814,2.814,0,0,1,1.325,2.39v.525a.721.721,0,0,1-.721.721H.471a.721.721,0,0,1-.721-.721v-.525a2.814,2.814,0,0,1,1.326-2.391,2.033,2.033,0,0,1,1.757-3.055Zm11.289,6.3a.33.33,0,0,0,.33-.33v-.525a2.427,2.427,0,0,0-1.3-2.151l-.2-.106.135-.183a1.625,1.625,0,0,0,.318-.973,1.644,1.644,0,0,0-1.642-1.642H2.833a1.641,1.641,0,0,0-1.322,2.614l.135.183-.2.106a2.426,2.426,0,0,0-1.3,2.152v.525a.33.33,0,0,0,.33.33ZM2.833,392.787h8.926a.983.983,0,1,1,0,1.966H2.833a.983.983,0,1,1,0-1.966Zm8.926,1.575a.592.592,0,1,0,0-1.184H2.833a.592.592,0,1,0,0,1.184Zm-9.188,1.05h9.451a1.773,1.773,0,0,1,1.771,1.771v.2H.8v-.2A1.773,1.773,0,0,1,2.571,395.412Zm10.817,1.575a1.382,1.382,0,0,0-1.366-1.184H2.571A1.382,1.382,0,0,0,1.2,396.987Z",
    transform: "translate(0.25 -391.737)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10677",
    "data-name": "Group 10677",
    transform: "translate(8.07 5.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10543",
    "data-name": "Group 10543",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M25.778,21.527a3.226,3.226,0,0,0-.617-.709l-2.394-2.088a.509.509,0,0,0-.2-.178L21.115,17.29l-6.7-5.846A1.534,1.534,0,0,0,13.963,9l.62-.62a2.051,2.051,0,0,0,1.979-.53,2.049,2.049,0,0,0,0-2.9L12.214.6A2.049,2.049,0,0,0,8.786,2.58L2.6,8.766a2.062,2.062,0,0,0-.53-.069,2.049,2.049,0,0,0-1.449,3.5l4.348,4.347A2.049,2.049,0,0,0,8.4,14.564l.619-.619a1.538,1.538,0,0,0,2.448.449L18.6,22.6a.514.514,0,0,0,.069.087l.029.026,2.127,2.444c.053.062.109.124.168.182a3.048,3.048,0,0,0,2.166.9,3.144,3.144,0,0,0,.431-.03,3.1,3.1,0,0,0,2.288-1.584A3.032,3.032,0,0,0,25.778,21.527ZM10.04,1.326a1.024,1.024,0,0,1,1.449,0l4.348,4.347a1.025,1.025,0,0,1-1.449,1.449L10.04,2.775h0A1.026,1.026,0,0,1,10.04,1.326Zm-2.9,14.492a1.026,1.026,0,0,1-1.449,0L1.345,11.47a1.025,1.025,0,0,1,1.449-1.45l4.348,4.348A1.025,1.025,0,0,1,7.142,15.818ZM9.3,12.212,7.866,13.644,3.519,9.3l5.8-5.8,4.348,4.348L12.228,9.283l-.014.014-2.9,2.9Zm1.83,1.069,0,0-.361.361a.512.512,0,0,1-.731-.718l2.91-2.91a.512.512,0,0,1,.869.368.508.508,0,0,1-.15.362L13.3,11.1l-.007.007Zm1.061.388,1.5-1.5,6.34,5.53-2.314,2.314Zm6.2,7.121L20.8,18.377l.774.675-2.513,2.513Zm6.6,3.331a2.084,2.084,0,0,1-1.534,1.069,2.036,2.036,0,0,1-1.732-.581c-.039-.039-.077-.08-.112-.122l0-.006L19.737,22.34l2.613-2.613,2.139,1.866,0,0a2.206,2.206,0,0,1,.423.486A2.023,2.023,0,0,1,24.985,24.121Z",
    transform: "translate(0.174 0.195)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109_-_Outline",
    "data-name": "Path 10109 - Outline",
    d: "M23.109,26.376a3.236,3.236,0,0,1-2.3-.957c-.062-.062-.122-.128-.179-.194l-2.117-2.433-.029-.026a.7.7,0,0,1-.087-.106l-7.008-8.052a1.728,1.728,0,0,1-2.263-.158,1.739,1.739,0,0,1-.206-.248l-.368.368a2.25,2.25,0,0,1-.605,2.055,2.244,2.244,0,0,1-3.17,0L.426,12.275A2.241,2.241,0,0,1,2.482,8.5L8.519,2.462A2.25,2.25,0,0,1,9.125.408a2.241,2.241,0,0,1,3.17,0l4.349,4.349a2.24,2.24,0,0,1-2.055,3.775L14.22,8.9a1.728,1.728,0,0,1,.406,2.469l7.993,6.972a.7.7,0,0,1,.166.123.71.71,0,0,1,.073.086l2.377,2.073a3.414,3.414,0,0,1,.652.749A3.225,3.225,0,0,1,26,24.664a3.291,3.291,0,0,1-2.429,1.68A3.347,3.347,0,0,1,23.109,26.376ZM11.421,14.064,18.7,22.429l.008.012a.325.325,0,0,0,.044.055l.018.016.011.009,2.137,2.455q.077.091.159.173a2.857,2.857,0,0,0,2.032.845,2.963,2.963,0,0,0,.405-.028,2.912,2.912,0,0,0,2.148-1.488,2.84,2.84,0,0,0-.095-2.9,3.037,3.037,0,0,0-.581-.667L22.57,18.805l-.014-.021a.327.327,0,0,0-.041-.05.321.321,0,0,0-.087-.061l-.023-.011L14.083,11.4l.138-.144a1.344,1.344,0,0,0-.394-2.144L13.582,9l.889-.889.106.028a1.872,1.872,0,0,0,.481.063,1.859,1.859,0,0,0,1.315-3.173L12.024.677a1.859,1.859,0,0,0-2.63,0,1.867,1.867,0,0,0-.48,1.8l.028.106L2.6,8.922l-.106-.028a1.875,1.875,0,0,0-.482-.063A1.859,1.859,0,0,0,.7,12.005l4.349,4.349a1.862,1.862,0,0,0,2.63,0,1.867,1.867,0,0,0,.48-1.8l-.028-.106.887-.887.116.243a1.347,1.347,0,0,0,2.145.394ZM23.112,25.351a2.221,2.221,0,0,1-1.58-.657c-.043-.043-.084-.088-.123-.134l0,0-1.982-2.277,2.866-2.866L24.567,21.4a2.4,2.4,0,0,1,.46.529,2.219,2.219,0,0,1,.074,2.235,2.274,2.274,0,0,1-1.675,1.165A2.3,2.3,0,0,1,23.112,25.351ZM19.946,22.3,21.7,24.314c.032.038.066.075.1.11a1.842,1.842,0,0,0,1.31.545,1.917,1.917,0,0,0,.262-.018,1.9,1.9,0,0,0,1.394-.974,1.828,1.828,0,0,0-.062-1.841,2.018,2.018,0,0,0-.386-.445l-.009-.008-2-1.747Zm-.945-.5-.926-1.064,2.666-2.666,1.063.927Zm-.4-1.046.423.487,2.225-2.225-.486-.424Zm-.945-.5-5.778-6.637,1.75-1.75,6.631,5.784ZM12.4,13.623l5.275,6.06L19.7,17.658l-6.054-5.281ZM6.36,16.255A1.208,1.208,0,0,1,5.5,15.9L1.151,11.55A1.216,1.216,0,0,1,2.87,9.83l4.35,4.35a1.215,1.215,0,0,1-.86,2.075Zm-4.349-6.4a.834.834,0,0,0-.59,1.424L5.77,15.629A.834.834,0,0,0,6.95,14.45L2.6,10.1A.828.828,0,0,0,2.011,9.856Zm8.336,4.075a.7.7,0,0,1-.505-1.193l2.913-2.913a.7.7,0,0,1,.989,1l-2.9,2.9A.7.7,0,0,1,10.347,13.931Zm2.9-3.924a.319.319,0,0,0-.224.09l-2.91,2.91a.315.315,0,0,0-.088.221.322.322,0,0,0,.55.228l2.9-2.9a.321.321,0,0,0-.228-.549ZM7.81,13.86,3.191,9.241,9.26,3.172l4.619,4.619L9.4,12.273l-.012.013-.005.005ZM3.731,9.241l4.08,4.08,1.3-1.3L9.127,12l2.9-2.9.016-.015,1.3-1.3L9.26,3.712ZM15.059,7.557A1.207,1.207,0,0,1,14.2,7.2L9.85,2.852a1.216,1.216,0,1,1,1.719-1.72l4.349,4.349a1.216,1.216,0,0,1-.86,2.075Zm-4.35-6.4a.834.834,0,0,0-.59,1.424l4.35,4.349a.834.834,0,1,0,1.179-1.18L11.3,1.4A.829.829,0,0,0,10.709,1.158Z",
    transform: "translate(0.229 0.249)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(278.501 704.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-2",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(245.885 662.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-2",
    "data-name": "Group 10671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-2",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-2",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-2",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-2",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-2",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-3",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(247.289 730.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-3",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-3",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-3",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-3",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-3",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-3",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-4",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(212.395 706.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-4",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-4",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-4",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-4",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-4",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-4",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudicialLands);
export default __webpack_public_path__ + "static/media/judicialLands.af78828f1660a8a20f6492ceb554ee19.svg";
export { ForwardRef as ReactComponent };